"use strict";
// https://www.figma.com/file/l62sFQ3ix9Wc4aV7DF8XHb/MKP-LIGHT?node-id=0%3A7243
// LAST SYNC: 10.01.21
Object.defineProperty(exports, "__esModule", { value: true });
exports.shape = void 0;
exports.shape = {
    borderRadius: 4,
};
//# sourceMappingURL=shape.js.map